import { CryptoJsService } from './../../services/crypto-js.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import jwtDecode from 'jwt-decode';
import { Message, MessageService } from 'primeng/api';
import { first, Subscription } from 'rxjs';
import { AppConfig } from 'src/app/models/appconfig';
import { ConfigService } from 'src/app/services/app.config.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { TranslateService } from '@ngx-translate/core';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styles: [`
    :host ::ng-deep .p-password input {
    width: 100%;
    padding:1rem;
    }

    :host ::ng-deep .pi-eye{
      transform:scale(1.6);
      margin-right: 1rem;
      color: var(--primary-color) !important;
    }

    :host ::ng-deep .pi-eye-slash{
      transform:scale(1.6);
      margin-right: 1rem;
      color: var(--primary-color) !important;
    }
  `]
})
export class LoginComponent implements OnInit, OnDestroy {
  public onAuthForm: FormGroup;
  valCheck: string[] = ['remember'];
  wrongNotificationCheck: boolean = true;
  password: string;

  config: AppConfig;
  userData: any;
  subscription: Subscription;
  date: any;
  loginId: any = '';
  ipAddress: any;
  status: any;


  constructor(private _formBuilder: FormBuilder, public configService: ConfigService, private authService: AuthenticationService, public router: Router, private service: MessageService, private cryptoJs: CryptoJsService,private translateService: TranslateService, private messageService: MessageService, private ipService: IpAddressService, private activityRecordService : ActivityRecordService,private loader: AppLoaderService) { }
  ngOnInit(): void {
    this.onAuthForm = this._formBuilder.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required]],
      remembercheck: ['', []],
    });

    this.config = this.configService.config;
    this.subscription = this.configService.configUpdate$.subscribe(config => {
      this.config = config;
    });
  }

  onLogin() {
    sessionStorage.removeItem("isFarmerLogin");
    this.loader.start();
    this.authService.login(this.f.email.value, this.cryptoJs.Encrypt(this.f.password.value))
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.loginId = data.role;
          this.activityRecordService.activityRecord(this.f.email.value, 'login', '', new Date(), 'Success');
          // console.log(data);
          if(data.officeCode){
            sessionStorage.setItem("officeCode", data.officeCode);
          }
          sessionStorage.setItem("User_name_while_login", this.f.email.value);
          sessionStorage.setItem("loginUserName", data?.officerName);
          sessionStorage.setItem("auth_token", data?.authToken);
          if (data.role == 'ABY_agency') {
            sessionStorage.setItem('isAtalBhujal', '1');
            sessionStorage.setItem('abyUserID', this.f.email.value);
          }
          this.userData = jwtDecode(data.authToken);
          if (data.role === 'DD Associate' || data.role === 'DMICADA' || data.role === 'DDMICADA'|| data.role === 'ADVISOR') {
            sessionStorage.setItem('userRole', data.role);
            sessionStorage.setItem('isDepartment', '1');
            sessionStorage.setItem('deptUserID', this.f.email.value);
            sessionStorage.setItem(this.cryptoJs.Encrypt('canEditMIData'), this.cryptoJs.Encrypt('yes'));
           if(data.role === 'ADVISOR') {
            this.router.navigate(['/department/report/timeline']);
            // this.router.navigate(['/department/dashboard/micada_geography']);
           } else if(sessionStorage.getItem('deptUserID') === 'D.A-9') {
            this.router.navigate(['/department/pond/tank-stage1'])
           }
           else{
            this.router.navigate(['/department/farmer-applications']);
           }
           
            
            return;
          }
          else if (data.role == 'Vendor') {
            sessionStorage.setItem('isVendor', '1');
            this.router.navigate(['/vendor']);
            sessionStorage.setItem('abyUserID', this.userData.sub);
            return;
          }
          else if (data.role == 'JE') {
            sessionStorage.setItem('isJE', '1');
            sessionStorage.setItem(this.cryptoJs.Encrypt('editBilledData'), this.cryptoJs.Encrypt('yes'));
            this.router.navigate(['/je']);
            return;
          }
          else if (data.role == 'CJE') {
            sessionStorage.setItem('isJE', '1');
            sessionStorage.setItem('isCJE', '1');
            sessionStorage.setItem(this.cryptoJs.Encrypt('editBilledData'), this.cryptoJs.Encrypt('yes'));
            this.router.navigate(['/cje']);
            return;
          }
          else if (data.role == 'SDO') {
            sessionStorage.setItem('isSDO', '1');
            sessionStorage.setItem(this.cryptoJs.Encrypt('editBilledData'), this.cryptoJs.Encrypt('yes'));
            this.router.navigate(['/sdo']);
            return;
          }
          else if (data.role == 'XEN') {
            sessionStorage.setItem('isXEN', '1');
            sessionStorage.setItem(this.cryptoJs.Encrypt('editBilledData'), this.cryptoJs.Encrypt('yes'));
            this.router.navigate(['/xen']);
            return;
          }
          else if (data.role == 'CXEN') {
            sessionStorage.setItem('isXEN', '1');
            sessionStorage.setItem('isCXEN', '1');
            sessionStorage.setItem(this.cryptoJs.Encrypt('editBilledData'), this.cryptoJs.Encrypt('yes'));
            this.router.navigate(['/cxen']);
            return;
          }
          else if (data.role == 'HelpDesk') {
            sessionStorage.setItem('isHelpdesk', '1');
            this.router.navigate(['/helpdesk']);
            return;
          }
          else if (data.role == 'ADMIN') {
            sessionStorage.setItem(this.cryptoJs.Encrypt('canEditMIData'), this.cryptoJs.Encrypt('yes'));
            this.router.navigate(['/admin/report/timeline']);
            // this.router.navigate(['/admin']);
            return;
          }
          else if (data.role == 'ABY_agency') {
            sessionStorage.setItem('isAtalBhujal', '1');
            sessionStorage.setItem('userId', this.userData.sub);
          }
          else if (data.role == 'CAO') {
            sessionStorage.setItem('isCAO', '1');
            this.router.navigate(['/cao']);
            return;
          }
          else if (data.role == 'Dev'){
            sessionStorage.setItem('isDev', '1');
            this.router.navigate(['/dev']);
            return;
          }
          else if (data.role == 'SubDev'){
            sessionStorage.setItem('isSubDev', '1');
            this.router.navigate(['/subdev']);
            return;
          }
          // this.router.navigate(['/dashboard']);
        },
        error: (res) => {
          this.loader.close();
          let errorArray = res;
          // console.log("error reposnse", res)
          this.activityRecordService.activityRecord(this.f.email.value, 'login', '', new Date(), errorArray[0]);
          if (errorArray.length) {
            this.service.add({ severity: 'error', summary: 'Error Message', detail: errorArray[0] });
          } else {
            this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! userid or password not correct.' });
          }
        },
        // complete: () => {
        //   console.log("completeeee");
        //   this.fetchDateTime();
        // },
      }
      );
  }

  get f() {
    return this.onAuthForm.controls;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // wrongNotification(event) {
  //   this.wrongNotificationCheck = !this.wrongNotificationCheck;
  //   console.log(event);
  //   if(event.value.name=='English')
  //   {
  //      this.translateService.use('en')
  //   }
  //   else{
  //       this.translateService.use('hd')
  //   }
   
  // }
}
